module.exports = __webpack_public_path__ + "img/pl.ed9d5529.svg";